/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
import { customElement } from 'solid-element';
import IconButton, { IconButtonProps, IconShape } from './IconButton';
import { ICustomElement, noShadowDOM } from 'component-register';
import { BtnClasses } from '../../types/common';
import type { IconSize } from '../Icon/icon-size';

// TypeScript declaration for the web component
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-icon-button': Partial<HTMLElement> &
        IconButtonProps &
        Partial<{ ref: ICustomElement }>;
    }
  }
}

export function defineSolidIconButton(): void {
  customElement(
    'tc-icon-button',
    {
      icon: '',
      title: '',
      color: BtnClasses.PRIMARY,
      size: 'icon-medium' as IconSize,
      shape: 'icon-circle' as IconShape,
      disabled: false,
      classes: '',
      'data-cy': 'icon-button',
    },
    (props, { element }) => {
      noShadowDOM();

      function clicked(): void {
        const evt = new CustomEvent<{ isOpen: boolean }>('icon-clicked', {
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      return (
        <IconButton
          title={props.title}
          icon={props.icon}
          color={props.color}
          size={props.size}
          shape={props.shape}
          disabled={props.disabled}
          classes={props.classes}
          data-cy={props['data-cy']}
          clicked={clicked}
        />
      );
    }
  );
}
